export default __webpack_public_path__ + "8df79f390c1c861c6d965ca33b257344.png";